import React, { Fragment } from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import mainImg from './img/main.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro35">
      <div className="intro35mobile">
        <div className="mainbackground">
          {background && <img src={background} className="bp1-abackground" />}
        </div>
        <div className="mask"></div>
        <div className="button-layout-container">
          <div className="button">
            <div
              className="sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button onClick={onSkipIntro} className="button1">
              <div className="button2"></div>
              <div className="rectangle"></div>
              <div className="pularintrodu347343o">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="main-layout-container">
          <div className="main">
            <div className="mainimage-layout-container">
              <img
                src={mainImg}
                className="mainimage anima-intro35-animate-enter4"
              />
            </div>
            <div className="couplesinglenamebride-layout-container">
              <div className="notranslate couplesinglenamebride anima-intro35-animate-enter7">
                {coupleSingleName.bride}
              </div>
            </div>
            {!!coupleSingleName.groom && (
              <Fragment>
                <div className="label1-layout-container">
                  <div className="label1 anima-intro35-animate-enter6">&</div>
                </div>
                <div className="couplesinglenamegr-layout-container">
                  <div className="notranslate couplesinglenamegr anima-intro35-animate-enter5">
                    {coupleSingleName.groom}
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
